import { createFileRoute } from "@tanstack/react-router";
import AboutDepression from "@/pages/AboutDepression";
export const Route = createFileRoute(
  "/contents/conditions/depression/about-depression",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "About Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Learn about depression affecting over 16 million U.S. adults. Discover biological causes, economic impact, suicide statistics, and neural network mechanisms.",
        },
        {
          property: "og:title",
          content: "About Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Learn about depression affecting over 16 million U.S. adults. Discover biological causes, economic impact, suicide statistics, and neural network mechanisms.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/contents/conditions/depression/about-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/contents/conditions/depression/about-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AboutDepression />;
}
